export const DEFAULT_LOCALE_CACHE_VERSION = '0'

const trimValue = (value?: string): string => value?.trim() ?? ''

export const resolveLocaleCacheVersion = (buildId?: string): string =>
    trimValue(buildId) || DEFAULT_LOCALE_CACHE_VERSION

export const buildLocaleLoadPath = (
    lng: string,
    ns: string,
    buildId?: string
): string => {
    const version = encodeURIComponent(resolveLocaleCacheVersion(buildId))

    return `/locales/${lng}/${ns}.json?v=${version}`
}
